import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { Error } from '../../shared/models/error.model';
import { RequestService } from '../../shared/services/request.service';
import { OrderStatus } from './enums/order-status.enum';
import { OrderRejectReason } from './models/order-reject-reason.model';
import { Order } from './models/order.model';

@Injectable()
export class OrderService {

	constructor(private requestService: RequestService) { }

	getOrders(establishmentId: number, placeId: number, isOpen: boolean, page?: number, size?: number, employeeId?: number): Promise<Array<Order>> {
		return new Promise((resolve, reject) => {
			// TODO: Tratar para pedidos somente delivery, carregar só os finished
			let urlRequest: string = APP_CONFIG.WEBSERVICE.GET_PENDING_ORDERS;
			const params: any = { };
			if (!isOpen) {
				urlRequest = APP_CONFIG.WEBSERVICE.GET_FINISHED_ORDERS;
				params.page = page;
				params.size = size;

				// Informado para o perfil de entregador
				// TODO: TESTAR
				// if (employeeId) {
				// 	urlRequest += "&employeeId=" + employeeId;
				// }
			}
			urlRequest += establishmentId ? "&establishmentId=" + establishmentId : "&placeId=" + placeId;
			urlRequest = this.requestService.buildUrlPathParams(params, urlRequest);
			// urlRequest = "./assets/resources/mock.json";
			this.requestService.getData(urlRequest).then((response: Array<Order>) => {
				//TODO: comentar linhas abaixo (simula response e paginação)
				// let from = ((page-1) * size) || 1;
				// let to = (page * size) || 20;
				// response = (response as any).orders.slice(from, to);
				//---- fim mock ----

				const orders: Array<Order> = [];
				if (response && response.length > 0) {
					for (const o of response) {
						orders.push(new Order(o));
					}
				}
				console.log(orders);
				resolve(orders || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	getOrder(orderId: number): Promise<Order> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams({ orderId: orderId }, APP_CONFIG.WEBSERVICE.GET_ORDER);
			// let urlRequest = "./assets/resources/mock.json";
			this.requestService.getData(urlRequest).then((response: Array<Order>) => {
				// ---- MOCK ----
				// response = [(response as any).orderDetail];
				//---- fim mock ----

				let order: Order;
				if (response && response.length > 0) {
					order = new Order(response[0]);
				}
				console.log(order);
				resolve(order);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	startOrder(orderId: number, isGroup: boolean): Promise<void> {
		return new Promise((resolve, reject) => {
			const data: any = {
				status: OrderStatus.IN_PRODUCTION['code'],
				orderId: orderId,
				isGroup: isGroup
			}
			this.requestService.postData(APP_CONFIG.WEBSERVICE.UPDATE_ORDER_STATUS, data).then(async () => {
				// Tratativa para resolver problema do back que envia a mensagem antes do pedido ter sido atualizado
				await this.delayOrder();
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	rejectOrder(orderRejectReason: OrderRejectReason, isGroup: boolean, employeeId: number): Promise<void> {
		return new Promise((resolve, reject) => {
			orderRejectReason.employeeId = employeeId;
			orderRejectReason.status = OrderStatus.CANCELED_BY_ESTABLISHMENT['code'];
			orderRejectReason.isGroup = isGroup;
			this.requestService.postData(APP_CONFIG.WEBSERVICE.UPDATE_ORDER_STATUS, orderRejectReason).then(async () => {
				// Tratativa para resolver problema do back que envia a mensagem antes do pedido ter sido atualizado
				await this.delayOrder();
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	finishOrder(orderId: number, isGroup: boolean): Promise<void> {
		return new Promise((resolve, reject) => {
			const data: any = {
				status: OrderStatus.FINISHED['code'],
				orderId: orderId,
				isGroup: isGroup
			}
			this.requestService.postData(APP_CONFIG.WEBSERVICE.UPDATE_ORDER_STATUS, data).then(async () => {
				// Tratativa para resolver problema do back que envia a mensagem antes do pedido ter sido atualizado
				await this.delayOrder();
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	finishOrderItem(orderItemId: number): Promise<void> {
		return new Promise((resolve, reject) => {
			this.requestService.postData(APP_CONFIG.WEBSERVICE.FINISH_ORDER_ITEM + "/" + orderItemId).then(async () => {
				// Tratativa para resolver problema do back que envia a mensagem antes do pedido ter sido atualizado
				await this.delayOrder();
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	undoFinishedOrderItem(orderItemId: number): Promise<void> {
		return new Promise((resolve, reject) => {
			const params: any = {
				orderItemId: orderItemId,
				status: OrderStatus.IN_PRODUCTION['code']
			};
			const urlRequest: string = this.requestService.buildUrlPathParams(params, APP_CONFIG.WEBSERVICE.UNDO_ORDER_ITEM_STATUS);
			this.requestService.postData(urlRequest).then(async () => {
				// Tratativa para resolver problema do back que envia a mensagem antes do pedido ter sido atualizado
				await this.delayOrder();
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	changeTable(establishmentId: number, fromIdTable: number, toIdTable: number): Promise<void> {
		return new Promise((resolve, reject) => {
			const data: any = {
				establishmentId: establishmentId,
				from: fromIdTable,
				to: toIdTable,
		   };
			this.requestService.putData(APP_CONFIG.WEBSERVICE.CHANGE_TABLE, data).then(async () => {
				// Tratativa para resolver problema do back que envia a mensagem antes do pedido ter sido atualizado
				await this.delayOrder();
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	confirmDelivered(orderId: number, employeeId: number, confirmPayment: boolean, isGroup: boolean): Promise<void> {
		return new Promise((resolve, reject) => {
			const data: any = {
				employeeId: employeeId,
				orderId: orderId,
				confirmPayment: confirmPayment,
				status: OrderStatus.DELIVERED['code'],
				isGroup: isGroup
			};
			this.requestService.postData(APP_CONFIG.WEBSERVICE.UPDATE_ORDER_STATUS, data).then(async () => {
				// Tratativa para resolver problema do back que envia a mensagem antes do pedido ter sido atualizado
				await this.delayOrder();
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	// Tratativa para resolver problema do back que envia a mensagem antes do pedido ter sido atualizado
	private delayOrder(): Promise<void> {
		return new Promise((resolve) => {
		  	setTimeout(() => {
				resolve();
		  	}, 1000);
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/orders.service.ts